import { register } from "../helpers/stimulus"

import DropdownController from "../controllers/navbar/dropdown_controller"
import NavbarController from "../controllers/navbar/navbar_controller"
import NavbarSlideController from "../controllers/navbar/navbar_slide_controller"
import ModalController from "../controllers/modal_controller"
import ModalTriggerController from "../controllers/modal_trigger_controller"

const setupNavbar = (): void => {
  register("navbar", NavbarController)
  register("navbar-dropdown", DropdownController)
  register("navbar-modal", ModalController)
  register("navbar-modal-trigger", ModalTriggerController)
  register("navbar-slide", NavbarSlideController)
  register("profile-menu-modal", ModalController)
  register("profile-menu-modal-trigger", ModalTriggerController)
}

export { setupNavbar }
